import Vue from "vue";
import "./plugins/axios";
import "./plugins/element";
import "./plugins/umy-ui";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission";
import "nprogress/nprogress.css";
import "./styles/element-variables.scss";
import "./styles/element-global.css";
import appMixin from "./mixin/app";
import "./directives/action";
import { getImageUri, copyClipboard } from "./utils/util";
import permission from "@/directives/permission";

Vue.directive("permission", permission);
Vue.config.productionTip = false;

Vue.prototype.$getImageUri = getImageUri;
Vue.prototype.$copyText = copyClipboard;

Vue.mixin(appMixin);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
